import {soundManager} from "soundmanager2";

export const appSetup = () => {
    soundManager.setup({debugMode: false});
}

appSetup();
